import { toNumber } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import Draggable from 'react-draggable';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

interface FloatingToolboxProps {
  name: string;
  title: string;
  isOpen: boolean;
  toggle: () => void;
  children: React.ReactNode;
}
const FloatingToolbox = ({
  name,
  title,
  isOpen,
  toggle,
  children
}: FloatingToolboxProps) => {
  const [resizeOnStart, setResizeOnStart] = useState<boolean>(true);
  const [position, setPosition] = useState({
    x: toNumber((localStorage.getItem("ftp_" + name + "_x") ?? 0)) ?? 0,
    y: toNumber((localStorage.getItem("ftp_" + name + "_y") ?? 0)) ?? 0
  });

  const [isDragging, setIsDragging] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });
  const [modalSize, setModalSize] = useState<'sm' | 'md' | 'lg' | 'xl' | undefined>('md');

  useEffect(() => {
    const updateSize = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setModalSize('sm');
      } else if (width >= 576 && width < 768) {
        setModalSize('md'); // default (medium size)
      } else if (width >= 768 && width < 992) {
        setModalSize('lg');
      } else {
        setModalSize('lg');
      }

      centerModal();
    };

    if (resizeOnStart) {
      setResizeOnStart(true);
      if (window.innerWidth > 768 && position.x == 0 && position.y == 0) { // first time showing and position is at 0
        setPosition({ x: 300, y: 300 });
      } else if (window.innerWidth <= 768) {
        setPosition({ x: 0, y: 20 });
      }
    }


    updateSize(); // Initial check


    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const modalRef = useRef<HTMLDivElement>(null);

  const handleMouseDown = (e: React.MouseEvent) => {
    // Only start drag on header and prevent event bubbling
    if ((e.target as HTMLElement).closest('.modal-header')) {
      e.stopPropagation();
      setIsDragging(true);
      setStartPos({
        x: e.clientX - position.x,
        y: e.clientY - position.y
      });
    }
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (!isDragging) return;

    const x = e.clientX - startPos.x;
    const y = e.clientY - startPos.y;
    setPosition({
      x: x,//e.clientX - startPos.x,
      y: y//e.clientY - startPos.y
    });
    localStorage.setItem("ftp_" + name + "_x", x.toString());
    localStorage.setItem("ftp_" + name + "_y", y.toString());
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  const centerModal = () => {
    if (isOpen && modalRef.current) {
      const modal = modalRef.current;
      const x = (window.innerWidth - modal.offsetWidth) / 2;
      const y = (window.innerHeight - modal.offsetHeight) / 3;
      setPosition({ x, y });
      localStorage.setItem("ftp_" + name + "_x", x.toString());
      localStorage.setItem("ftp_" + name + "_y", y.toString());

      console.log('center modal to ' + x + ',' + y);
    }
  }

  useEffect(() => {
    centerModal();
    // if (isOpen && modalRef.current) {
    //   const modal = modalRef.current;
    //   const x = (window.innerWidth - modal.offsetWidth) / 2;
    //   const y = (window.innerHeight - modal.offsetHeight) / 3;
    //   setPosition({ x, y });
    // }
  }, [isOpen]);

  // Add this to prevent clicks inside modal from reaching main window
  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{
        position: 'fixed',
        left: `${position.x}px`,
        top: `${position.y}px`,
        margin: 0,
        zIndex: 1050,
        pointerEvents: 'auto' // Ensure modal doesn't block clicks behind it
      }}
      backdrop={false}
      keyboard={true}
      modalClassName="draggable-modal"
      onMouseDown={handleMouseDown}
      onClick={handleModalClick} // Add click handler
      innerRef={modalRef}
      size={modalSize}
    >
      <ModalHeader toggle={toggle} style={{ cursor: 'move' }} className="bg-primary">
        <span className="text-white">{title}</span>
      </ModalHeader>
      <ModalBody onClick={handleModalClick} className="p-3">
        {children}
      </ModalBody>
    </Modal>
  );
};

export default FloatingToolbox;
